export interface Phoneme {
  sound: string;
  letters: string;
  type: 'consonant' | 'vowel' | 'digraph' | 'blend' | 'vowel_team' | 'r_controlled' | 'diphthong' | 'final_stable';
}

export interface Word {
  word: string;
  word_type: string;
  sentence: string;
  imageQuery: string;
  word_audio: string; 
  sentence_audio: string; // Added sentence_audio property
}

export interface GradeLevel {
  name: string;
}

export const gradeLevels: GradeLevel[] = [
  {
    name: "Kindergarten",    
  },
  {
    name: "First",
  },
  {
    name: "Second",
  },
  {
    name: "Third",
  }
];